export const chartIntervals = ['24 H', '7 D', '1 M', '1 Y', 'MAX'];

export const chartSourceInfo = { name: 'CoinGecko', href: 'https://www.coingecko.com/' };

export const intervalToDays = {
  '24 H': 1,
  '7 D': 7,
  '1 M': 30,
  '1 Y': 365,
  MAX: 'max',
};

export const intervalToFormatType = {
  '24 H': 'hour',
  '7 D': 'day',
  '1 M': 'month_before_days',
  '1 Y': 'month',
  MAX: 'default',
};
